var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionsAnswered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.999,
    height: 39.999
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4835"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 219",
    fill: "none",
    stroke: "#626262",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 202",
    d: "M20 8A12 12 0 118 20 12 12 0 0120 8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 203",
    d: "M13.6 17.9l1.307 1.855a.56.56 0 00.776.154.565.565 0 00.135-.126l4.185-5.3"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 82",
    fill: "none",
    d: "M0 0h39.999v39.999H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 216",
    fill: "none",
    stroke: "#626262",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 17",
    d: "M20 21l5 5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    d: "M20 26l5-5"
  })))));
}
export default SvgIconQuestionsAnswered;